﻿import { IndexDbService } from "./indexDbService";

(function () {
    'ngInject';

    angular.module('app.shared.services').factory('TestImageService', testImageService);

    const indexDbService = new IndexDbService();

    function testImageService($q) {
        function previewImageOnPlaceholder(file, canvas, placeHolderId, isFromStep2 = false, isPlaceholder = false, firstStepPlaceholder = null) {
            return $q(function (resolve, _) {
                if (!file) return resolve();
                // Read the file
                const fr = new FileReader();
                fr.onload = function () {
                    //we have to iterate over the entire array to cover those cases in which there are multiple images
                    //with the same ID's
                    const objects = canvas.getObjects().filter(
                        o => o.type === 'image-placeholder' && o.id === placeHolderId
                    );
                    for (const object of objects) {
                        (function (canvasObject) {
                            const imgAux = document.createElement('img');
                            imgAux.onload = function () {
                                canvasObject.setElement(imgAux);
                                canvas.renderAll();
                                resolve();
                            };
                            imgAux.src = fr.result;
                            canvasObject.testingUrl = imgAux.src;
                            indexDbService.findAndEditValue(canvasObject.uuid, fr.result);
                            if (isPlaceholder && isFromStep2 && firstStepPlaceholder) firstStepPlaceholder.testingUrl = imgAux.src;
                        })(object);
                    }
                };
                fr.readAsDataURL(file);
            });
        }

        function showStaticImage(canvas, imgPlaceholder, imageProperties) {
            const imgAux = document.createElement('img');
            imgAux.onload = function () {
                imgPlaceholder.setElement(imgAux);
                canvas.renderAll();
            };
            imgAux.setAttribute('crossOrigin', 'anonymous');
            imgAux.src = imageProperties.imageUrl;
        }

        function showStaticImageSvg(canvas, imgPlaceholder, imageProperties) {
            fetch(imageProperties.imageUrl)
                .then((response) => response.text())
                .then((text) => {
                    imgPlaceholder.set('svgString', text);
                    canvas.requestRenderAll();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        }

        return {
            previewImageOnPlaceholder: previewImageOnPlaceholder,
            showStaticImage: showStaticImage,
            showStaticImageSvg: showStaticImageSvg
        };
    }
})();
